import { render, staticRenderFns } from "./OwnPadminActivityLog.vue?vue&type=template&id=2cf11dd0&scoped=true"
import script from "./OwnPadminActivityLog.vue?vue&type=script&lang=js"
export * from "./OwnPadminActivityLog.vue?vue&type=script&lang=js"
import style0 from "./OwnPadminActivityLog.vue?vue&type=style&index=0&id=2cf11dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf11dd0",
  null
  
)

export default component.exports